
// const mercadoPagoPublicKey = 'TEST-d53c71a4-9e46-4fd3-ad38-c52528346e5d';
const mercadoPagoPublicKey = 'APP_USR-03badd95-615c-4b02-bb60-5ff9fc3b4e86';

function getMercadoPagoPublicKey() {
    return mercadoPagoPublicKey
}

export {
    getMercadoPagoPublicKey
}